import React from 'react';
import RecipeDescription from '../components/RecipeDescription';

const RecipeDetail = () => {
  return (
    <div className="home-page">
      <RecipeDescription />
    </div>
  );
};

export default RecipeDetail;